import React from 'react';
import Hero from './components/Hero';
import ClientLogos from './components/ClientLogos';
import FeaturedProjects from './components/FeaturedProjects';
import PartnerWithUs from './components/PartnerWithUs';
import Services from './components/Services';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import CaseStudies from './components/CaseStudies';
import PortfolioShowcase from './components/PortfolioShowcase';
import FAQ from './components/FAQ';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            <div className="text-2xl font-bold">AI Automations</div>
            <nav className="hidden md:flex space-x-8">
              <a href="#services" className="text-gray-300 hover:text-white transition-colors">Services</a>
              <a href="#process" className="text-gray-300 hover:text-white transition-colors">Process</a>
              <a href="#case-studies" className="text-gray-300 hover:text-white transition-colors">Case Studies</a>
              <a href="#portfolio" className="text-gray-300 hover:text-white transition-colors">Portfolio</a>
            </nav>
            <a 
              href="#contact" 
              className="bg-accent hover:bg-accent-light text-white font-medium px-4 py-2 rounded-md transition-all duration-300"
            >
              Book a Call
            </a>
          </div>
        </div>
      </header>
      
      <main>
        <section id="hero">
          <Hero />
        </section>
        
        <section id="clients">
          <ClientLogos />
        </section>
        
        <section id="featured-projects">
          <FeaturedProjects />
        </section>
        
        <section id="partner">
          <PartnerWithUs />
        </section>
        
        <section id="services">
          <Services />
        </section>
        
        <section id="process">
          <Process />
        </section>
        
        <section id="testimonials">
          <Testimonials />
        </section>
        
        <section id="case-studies">
          <CaseStudies />
        </section>
        
        <section id="portfolio">
          <PortfolioShowcase />
        </section>
        
        <section id="faq">
          <FAQ />
        </section>
        
        <section id="contact">
          <CallToAction />
        </section>
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
